webpackJsonp([209],{

/***/ 1146:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "页面切换时显示loading | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 1961:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1146),
  /* template */
  __webpack_require__(2301),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/vue-show-loading-163.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] vue-show-loading-163.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-665e0988", Component.options)
  } else {
    hotAPI.reload("data-v-665e0988", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2301:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("页面切换显示loading")]), _vm._v(" "), _c('p', [_vm._v("移动端如果使用异步组件加载那么还是需要一点等待时间的，在网络慢时等待时间会更长。显示"), _c('code', [_vm._v("Loading")]), _vm._v("状态缓解一下用户等待情绪就十分重要。")]), _vm._v(" "), _c('p', [_vm._v("如果你使用"), _c('code', [_vm._v("vue-router")]), _vm._v("和"), _c('code', [_vm._v("vuex")]), _vm._v("，那么可以很容易实现。")]), _vm._v(" "), _c('p', [_vm._v("首先，注册一个"), _c('code', [_vm._v("module")]), _vm._v("来保存状态")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("const")]), _vm._v(" store = "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("new")]), _vm._v(" Vuex.Store({}) "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 这里你可能已经有其他 module")]), _vm._v("\n\nstore.registerModule("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v(", { "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 名字自己定义")]), _vm._v("\n  state: {\n    "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("isLoading")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-literal"
  }, [_vm._v("false")]), _vm._v("\n  },\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("mutations")]), _vm._v(": {\n    updateLoadingStatus (state, payload) {\n      state.isLoading = payload.isLoading\n    }\n  }\n})\n")])]), _vm._v(" "), _c('p', [_vm._v("然后使用"), _c('code', [_vm._v("vue-router")]), _vm._v("的"), _c('code', [_vm._v("beforeEach")]), _vm._v("和"), _c('code', [_vm._v("afterEach")]), _vm._v("来更改"), _c('code', [_vm._v("loading")]), _vm._v("状态")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("router.beforeEach("), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("function")]), _vm._v(" ("), _c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("to, from, next")]), _vm._v(") ")]), _vm._v("{\n  store.commit("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'updateLoadingStatus'")]), _vm._v(", {"), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("isLoading")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-literal"
  }, [_vm._v("true")]), _vm._v("})\n  next()\n})\n\nrouter.afterEach("), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("function")]), _vm._v(" ("), _c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("to")]), _vm._v(") ")]), _vm._v("{\n  store.commit("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'updateLoadingStatus'")]), _vm._v(", {"), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("isLoading")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-literal"
  }, [_vm._v("false")]), _vm._v("})\n})\n")])]), _vm._v(" "), _c('p', [_vm._v("在"), _c('code', [_vm._v("App.vue")]), _vm._v("里使用"), _c('code', [_vm._v("loading")]), _vm._v("组件并从"), _c('code', [_vm._v("vuex")]), _vm._v("获取"), _c('code', [_vm._v("isLoading")]), _vm._v("状态")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("loading")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("v-model")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"isLoading\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("loading")]), _vm._v(">")]), _vm._v("\n")])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Loading } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { mapState } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vuex'")]), _vm._v("\n\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("default")]), _vm._v(" {\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("components")]), _vm._v(": {\n    Loading\n  },\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("computed")]), _vm._v(": {\n    ...mapState({\n      "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("isLoading")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("state")]), _vm._v(" =>")]), _vm._v(" state.vux.isLoading\n    })\n  }\n}\n")])]), _vm._v(" "), _c('p', [_vm._v("done.")]), _vm._v(" "), _c('p', [_vm._v("如果你觉得在加载比较快时"), _c('code', [_vm._v("Loading")]), _vm._v("组件一闪而过体验也不大好，那么你可以延迟设置"), _c('code', [_vm._v("loading=false")]), _vm._v("。")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-665e0988", module.exports)
  }
}

/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1961);

/***/ })

});


// WEBPACK FOOTER //
// 209.bab4d483.js